import { render, staticRenderFns } from "./SociosRenovar.vue?vue&type=template&id=5f612b84&"
import script from "./SociosRenovar.vue?vue&type=script&lang=js&"
export * from "./SociosRenovar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports